/* eslint-disable no-console */
import {SearchOutlined} from '@ant-design/icons';
import type {InputRef} from 'antd';
import {Flex, Input, Table as TableAnt} from 'antd';
import {ColumnType, ColumnsType} from 'antd/es/table';
import React, {useEffect, useRef, useState} from 'react';

import {
  blockAccessTypes,
  blockModelMessages
} from '../../constants/blockPageConstatnts';
import FilteredUnit, {defaultCountry} from '../../constants/FilteredUnit';
import {SampleExcel} from '../../constants/SampleExcel';
// import {OPKey} from '../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import MapView from '../../pages/orgManager/Utils/FacilityAndOwner/Utils/MapView';
import {uploadTypes} from '../../services/constants/uploadTypes';
import {APITypeEnum} from '../../services/interface/tableAPIType';
import activeFacilityCount from '../../services/modules/OM/activeFacilityCount';
import facilityDetails from '../../services/modules/OM/facilityDetails';
import facilityDetailsFetch from '../../services/modules/OM/facilityDetailsFetch';
// import {excelSwitch} from '../../shared/commonFunctions';
import useCompanyStore, {
  accessModule,
  countModule
} from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
// import useUserStore from '../../store/userStore/userStore';
// import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import {formatIndian} from '../../utils/formatIndian';
import mapAndFilter from '../../utils/mapCountry';
import {
  hasMaxLimitReached,
  getModuleDataLimit,
  getSubscriptionPlanType
  // getAvailableDataLimit
} from '../../utils/SubscriptionHelper';
import BlockAccessPage from '../BlockAccess/BlockAccessPage';
import {
  labelFromOtherStored,
  OTHER_VALUE_PREFIX
} from '../CustomInputs/Select/SelectWithOtherOption';
import {objTypes} from '../DrawerForm/Constants/commonConstants';
import DrawerForm from '../DrawerForm/Utils/DrawerForm';
import {yearKeyLabel} from '../Forms/Constants/IP/commonKeyLabel';
import {
  FacilityKey,
  FacilityLabel
} from '../Forms/Constants/IP/FacilityKeyLabel';
import FacilityForm from '../Forms/FacilityForm';
import JobsModal from '../Jobs/JobsModal';
import Loader from '../Loader/Loader';

import {facilityTypeIds, Title, yesNo} from './Constants/Common';
import {defaultCol} from './Interface/ITable';
import ActionsButton from './Utils/ActionsButton';
import {createBulkRowSelection} from './Utils/TableBulkSelectionBar';
import TableTitleHeader from './Utils/TableTitleHeader';

const FacilityTable: React.FC<{
  isListView: boolean;
  dataSource: any[];
  setDataSource: React.Dispatch<React.SetStateAction<any[]>>;
  selectedYear: string;
}> = ({isListView, dataSource, setDataSource, selectedYear}) => {
  interface DataType {
    key: React.Key;
    type: number;
    name: string;
    address: string;
    isLeased: boolean;
    numberOfEmployee: number;
    bioDiversityProtected: boolean;
    area: number;
    floorSpace: number;
    city: number;
    state: number;
    country: number;
    pincode: string;
    taxIdentityNumber: string;
    isBiodiversityProtectedArea: boolean;
    isAdjacentToProtectedArea: boolean;
    isWaterScarceArea: boolean;
    hasSevereBiodiversityImpact: boolean;
    areaImpacted: number;
    assetLessorName: string;
    assetLessorMobile: string;
    assetLessorRentedFrom: string;
    assetLessorRentedTo: string;
    _id: string;
  }

  const [showModel, setShowModel] = useState(false);
  const [showJobs, setShowJobs] = useState(false);
  const [editData, setEditData] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const companyId = useCompanyStore.getState().companyId;
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [selectedCountry, setSelectedCountry] =
    useState<string>(defaultCountry);

  const countryOption = useJSONStore.getState().country;
  const stateOption = useJSONStore.getState().states;
  const cityOption = useJSONStore.getState().city;
  // const rating = useJSONStore.getState().rating;
  // const resType = useJSONStore.getState().resType;

  const facilityType = useJSONStore((state) => state.facilityType);
  // const companyDetails = useCompanyStore.getState().companyDetails;
  const triggerFacilityRefresh = useCompanyStore(
    (state) => state.triggerFacilityRefresh
  );

  const checkHeadquarterAvailable = () => {
    const result = dataSource?.filter(
      (item: any) => item?.type === facilityTypeIds.headquarter
    );
    const isExist = result?.length > 0;

    return isExist;
  };

  useEffect(() => {
    if (refresh || triggerFacilityRefresh) {
      setIsRefresh(true);
      Promise.all([
        facilityDetailsFetch(
          APITypeEnum.GET_ALL,
          undefined,
          `${companyId}/${selectedYear}`
        ),
        facilityDetails(APITypeEnum.GET_ALL, true),
        activeFacilityCount()
      ])
        .then(([res]) => {
          setDataSource(
            res.map((data: any) => {
              return {
                ...data,
                fullAddress: `${data?.[FacilityKey.ADDRESS]}, ${cityOption.find(
                  (item: any) => {
                    return item.value === data?.[FacilityKey.CITY];
                  }
                )?.label}, ${stateOption.find((item: any) => {
                  return item.value === data?.[FacilityKey.STATE];
                })?.label}, ${countryOption.find((item: any) => {
                  return item.value === data?.[FacilityKey.COUNTRY];
                })?.label}, ${data?.[FacilityKey.PINCODE]}`
              };
            })
          );
        })
        .catch(() => {})
        .finally(() => {
          setIsRefresh(false);
          // setToReset(true);
          setRefresh(false);
          if (triggerFacilityRefresh) {
            useCompanyStore.getState().setTriggerFacilityRefresh(false);
          }
        });
    }
  }, [refresh, triggerFacilityRefresh]);

  useEffect(() => {
    if (selectedYear) {
      setIsRefresh(true);
      facilityDetailsFetch(
        APITypeEnum.GET_ALL,
        undefined,
        `${companyId}/${selectedYear}`
      )
        .then((res) => {
          setDataSource(
            res.map((data: any) => {
              return {
                ...data,
                fullAddress: `${data?.[FacilityKey.ADDRESS]}, ${cityOption.find(
                  (item: any) => {
                    return item.value === data?.[FacilityKey.CITY];
                  }
                )?.label}, ${stateOption.find((item: any) => {
                  return item.value === data?.[FacilityKey.STATE];
                })?.label}, ${countryOption.find((item: any) => {
                  return item.value === data?.[FacilityKey.COUNTRY];
                })?.label}, ${data?.[FacilityKey.PINCODE]}`
              };
            }) ?? []
          );
        })
        .catch(() => {
          setDataSource([]);
        })
        .finally(() => {
          setIsRefresh(false);
        });
    }
  }, [selectedYear]);

  const facilityKeyLabel = [
    {
      key: yearKeyLabel.key,
      label: yearKeyLabel.label,
      type: objTypes.string
    },
    {
      key: FacilityKey.FACILITY_NAME,
      label: FacilityLabel.FACILITY_NAME,
      type: objTypes.string
    },
    {
      key: FacilityKey.FACILITY_TYPE,
      label: FacilityLabel.FACILITY_TYPE,
      type: objTypes.json_has_other_option,
      format: facilityType,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.LEASED,
      label: FacilityLabel.LEASED,
      type: objTypes.json,
      format: yesNo,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.LESSOR_NAME,
      label: FacilityLabel.LESSOR_NAME,
      type: objTypes.string,
      relatedKey: FacilityKey.LEASED
    },
    {
      key: FacilityKey.MOBILE_NO,
      label: FacilityLabel.MOBILE_NO,
      type: objTypes.phoneNumber,
      relatedKey: FacilityKey.LEASED
    },
    {
      key: FacilityKey.RENTED_FROM,
      label: FacilityLabel.RENTED_FROM,
      type: objTypes.date,
      format: 'DD-MM-YYYY',
      relatedKey: FacilityKey.LEASED
    },
    {
      key: FacilityKey.RENTED_TO,
      label: FacilityLabel.RENTED_TO,
      type: objTypes.date,
      format: 'DD-MM-YYYY',
      relatedKey: FacilityKey.LEASED
    },
    {
      key: FacilityKey.NO_EMP,
      label: FacilityLabel.NO_EMP,
      type: objTypes.number,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.FLOOR_SPACE,
      label: FacilityLabel.FLOOR_SPACE,
      type: objTypes.number,
      unit: FilteredUnit(selectedCountry).area,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.ADDRESS,
      label: FacilityLabel.ADDRESS,
      type: objTypes.string
    },
    {
      key: FacilityKey.COUNTRY,
      label: FacilityLabel.COUNTRY,
      type: objTypes.json,
      format: countryOption
    },
    {
      key: FacilityKey.STATE,
      label: FacilityLabel.STATE,
      type: objTypes.json,
      format: stateOption
    },
    {
      key: FacilityKey.CITY,
      label: FacilityLabel.CITY,
      type: objTypes.json,
      format: cityOption
    },
    {
      key: FacilityKey.PINCODE,
      label: FacilityLabel.PINCODE,
      type: objTypes.string
    },
    {
      key: FacilityKey.GST,
      label: FacilityLabel.GST,
      type: objTypes.string,
      relatedKey: FacilityKey.COUNTRY
    },
    // ...(companyDetails?.[OPKey.SUB_CATEGORY] === 6
    //   ? [
    //       {
    //         key: FacilityKey.rating,
    //         label: FacilityLabel.rating,
    //         type: objTypes.json,
    //         format: rating
    //       },
    //       {
    //         key: FacilityKey.occupancyRate,
    //         label: FacilityLabel.occupancyRate,
    //         type: objTypes.number,
    //         unit: '% / Year'
    //       },
    //       {
    //         key: FacilityKey.totalNoOfRooms,
    //         label: FacilityLabel.totalNoOfRooms,
    //         type: objTypes.number
    //       },
    //       {
    //         key: FacilityKey.averageRoomSize,
    //         label: FacilityLabel.averageRoomSize,
    //         type: objTypes.number,
    //         unit: FilteredUnit(selectedCountry).area
    //       }
    //     ]
    //   : []),
    // ...(companyDetails?.[OPKey.SUB_CATEGORY] === 8
    //   ? [
    //       {
    //         key: FacilityKey.resType,
    //         label: FacilityLabel.resType,
    //         type: objTypes.json,
    //         format: resType
    //       },
    //       {
    //         key: FacilityKey.averageMealsPerYear,
    //         label: FacilityLabel.averageMealsPerYear,
    //         type: objTypes.number,
    //         unit: 'per Year'
    //       }
    //     ]
    //   : []),
    {
      key: FacilityKey.BIO_PROTECTED,
      label: FacilityLabel.BIO_PROTECTED,
      type: objTypes.boolean,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.SEVERE_IMPACT,
      label: FacilityLabel.SEVERE_IMPACT,
      type: objTypes.boolean,
      isGreen: 'yes',
      relatedKey: FacilityKey.BIO_PROTECTED
    },
    {
      key: FacilityKey.IMPACTED_AREA,
      label: FacilityLabel.IMPACTED_AREA,
      type: objTypes.number,
      unit: FilteredUnit(selectedCountry).area,
      relatedKey: FacilityKey.SEVERE_IMPACT,
      checkRelatedKeyFalsy: true
    },
    {
      key: FacilityKey.BIO_ADJACENT_FACILITY,
      label: FacilityLabel.BIO_ADJACENT_FACILITY,
      type: objTypes.boolean,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.WATER_SCARED,
      label: FacilityLabel.WATER_SCARED,
      type: objTypes.boolean,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.ADD_TO_PAST_YEARS,
      label: FacilityLabel.ADD_TO_PAST_YEARS,
      type: objTypes.boolean,
      isGreen: 'yes'
    },
    {
      key: FacilityKey.PAST_YEAR_FROM,
      label: FacilityLabel.PAST_YEAR_FROM,
      type: objTypes.string,
      relatedKey: FacilityKey.ADD_TO_PAST_YEARS
    },
    {
      key: FacilityKey.PAST_YEAR_TO,
      label: FacilityLabel.PAST_YEAR_TO,
      type: objTypes.string,
      relatedKey: FacilityKey.ADD_TO_PAST_YEARS
    }
  ];

  const handleDelete = (_id: string[] | string) => {
    Promise.all([
      facilityDetailsFetch(APITypeEnum.DELETE_ALL, {
        facilities: _id,
        year: selectedYear
      }),
      facilityDetails(APITypeEnum.GET_ALL, true)
    ])
      .then(() => {
        setSelectedRowKeys([]);
        setRefresh(true);
        // setToReset(true);
      })
      .catch(() => {});
  };

  const handleSelectAll = () => {
    setSelectedRowKeys(
      dataSource
        .filter((row) => row.type !== facilityTypeIds.headquarter)
        .map((row) => row._id)
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sorter = (key: keyof DataType) => {
    return {
      sorter: (a: DataType, b: DataType) => {
        const valueA = a[key];
        const valueB = b[key];
        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return valueA - valueB;
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return valueA.localeCompare(valueB);
        }

        return 0;
      }
    };
  };

  const searchInput = useRef<InputRef>(null);

  const SearchFilter = (
    title: string,
    dataIndex: keyof DataType
  ): defaultCol & ColumnType<DataType> => {
    return {
      filterDropdown: ({selectedKeys, setSelectedKeys, confirm}) => {
        return (
          <div
            style={{padding: 8}}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          >
            <Input
              ref={searchInput}
              value={selectedKeys[0]}
              placeholder={`Search ${title}`}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              allowClear
            />
          </div>
        );
      },
      filterIcon: <SearchOutlined />,
      // filterDropdownProps:{autoAdjustOverflow:true},
      onFilter: (value, record) => {
        return record[dataIndex]
          ?.toString()
          .toLowerCase()
          .includes(value?.toString().toLowerCase());
      },
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      }
    };
  };

  const columns: Array<defaultCol & ColumnsType<any>[0]> = [
    {
      title: FacilityLabel.FACILITY_NAME,
      dataIndex: FacilityKey.FACILITY_NAME,
      editable: true,
      // ...sorter(FacilityKey.FACILITY_NAME as keyof DataType),
      ...SearchFilter(
        FacilityLabel.FACILITY_NAME,
        FacilityKey.FACILITY_NAME as keyof DataType
      )
    },
    {
      title: FacilityLabel.FACILITY_TYPE,
      dataIndex: FacilityKey.FACILITY_TYPE,
      editable: true,
      type: 'select',
      filterer: facilityType,
      filters: mapAndFilter(
        dataSource,
        facilityType,
        FacilityKey.FACILITY_TYPE,
        undefined,
        true
      ).map((item) => {
        return {text: item.label, value: item.value};
      }),
      onFilter: (value, record) => {
        return record[FacilityKey.FACILITY_TYPE] === value;
      },
      render: (value) => {
        const isNumber = typeof value === 'number';

        return (
          <>
            {!isNumber
              ? value?.startsWith(OTHER_VALUE_PREFIX)
                ? labelFromOtherStored(value)
                : value ?? '-'
              : facilityType.find((item) => {
                  return item.value === value;
                })?.label ?? '-'}
          </>
        );
      }
    },

    {
      title: FacilityLabel.LEASED,
      dataIndex: FacilityKey.LEASED,
      editable: true,
      type: 'select',
      filterer: yesNo,
      filters: yesNo.map((item) => {
        return {text: item.label, value: item.value};
      }),
      onFilter: (value, record) => {
        return record[FacilityKey.LEASED] === value;
      },
      render: (value) => {
        return (
          <>
            {
              yesNo.find((item) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: FacilityLabel.NO_EMP,
      type: 'number',
      dataIndex: FacilityKey.NO_EMP,
      // ...sorter(FacilityKey.NO_EMP as keyof DataType),
      ...SearchFilter(
        FacilityLabel.NO_EMP,
        FacilityKey.NO_EMP as keyof DataType
      ),
      render: (value) => {
        return formatIndian(value);
      }
    },
    {
      title: FacilityLabel.FLOOR_SPACE,
      type: 'number',
      dataIndex: FacilityKey.FLOOR_SPACE,
      editable: true,
      // ...sorter(FacilityKey.FLOOR_SPACE as keyof DataType),
      ...SearchFilter(
        FacilityLabel.FLOOR_SPACE,
        FacilityKey.FLOOR_SPACE as keyof DataType
      ),
      render: (value, record) => {
        return `${formatIndian(value)} ${
          value ? FilteredUnit(record.country).area : ''
        }`;
      }
    },
    {
      title: FacilityLabel.ADDRESS,
      dataIndex: 'fullAddress',
      editable: true,
      ...SearchFilter(FacilityLabel.ADDRESS, 'fullAddress' as keyof DataType),
      render: (value) => {
        return <div>{value}</div>;
      }
    },

    // {
    //   title: FacilityLabel.CITY,
    //   dataIndex: FacilityKey.CITY,
    //   // width: '120px',
    //   editable: true,
    //   type: 'select',
    //   filterer: FacilityOptions,
    //   filters: FacilityOptions.map((item) => {
    //     return {text: item.label, value: item.value};
    //   }),
    //   onFilter: (value, record) => {
    //     return record[FacilityKey.CITY] === value;
    //   },
    //   render: (value) => {
    //     return (
    //       <>
    //         {
    //           FacilityOptions.find((item) => {
    //             return item.value === value;
    //           })?.label
    //         }
    //       </>
    //     );
    //   }
    // },
    // {
    //   title: FacilityLabel.STATE,
    //   dataIndex: FacilityKey.STATE,
    //   // width: '120px',
    //   editable: true,
    //   type: 'select',
    //   filterer: FacilityOptions,
    //   filters: FacilityOptions.map((item) => {
    //     return {text: item.label, value: item.value};
    //   }),
    //   onFilter: (value, record) => {
    //     return record[FacilityKey.STATE] === value;
    //   },
    //   render: (value) => {
    //     return (
    //       <>
    //         {
    //           FacilityOptions.find((item) => {
    //             return item.value === value;
    //           })?.label
    //         }
    //       </>
    //     );
    //   }
    // },
    // {
    //   title: FacilityLabel.COUNTRY,
    //   dataIndex: FacilityKey.COUNTRY,
    //   editable: true,
    //   type: 'select',
    //   filterer: countryOption,
    //   filters: mapAndFilter(facility, countryOption, FacilityKey.COUNTRY).map(
    //     (item) => {
    //       return {text: item.label, value: item.value};
    //     }
    //   ),
    //   onFilter: (value, record) => {
    //     return record[FacilityKey.COUNTRY] === value;
    //   },
    //   render: (value) => {
    //     return (
    //       <>
    //         {
    //           countryOption.find((item) => {
    //             return item.value === value;
    //           })?.label
    //         }
    //       </>
    //     );
    //   }
    // },
    // {
    //   title: FacilityLabel.PINCODE,
    //   dataIndex: FacilityKey.PINCODE,
    //   editable: true,
    //   ...SearchFilter(
    //     FacilityLabel.PINCODE,
    //     FacilityKey.PINCODE as keyof DataType
    //   )
    // },
    // {
    //   title: FacilityLabel.LIST_BIO_PROTECTED,
    //   dataIndex: FacilityKey.BIO_PROTECTED,
    //   type: 'select',
    //   filterer: yesNo,
    //   filters: yesNo.map((item) => {
    //     return {text: item.label, value: item.value};
    //   }),
    //   onFilter: (value, record) => {
    //     return record?.[FacilityKey.BIO_PROTECTED] === value;
    //   },
    //   editable: true,
    //   render: (value) => {
    //     return (
    //       <>
    //         {
    //           yesNo.find((item) => {
    //             return item.value === value;
    //           })?.label
    //         }
    //       </>
    //     );
    //   }
    // },
    ...(!hasUserRole(UserRole.View_Only)
      ? ([
          {
            title: Title.actionTitle,
            dataIndex: 'operation',
            type: '',
            fixed: 'right',
            width: '200px !important',
            render: (value: any, record: any) =>
              dataSource.length >= 1 ? (
                <ActionsButton
                  record={record}
                  setShowModel={setShowModel}
                  setEditData={setEditData}
                  setIsEdit={setIsEdit}
                  handleDelete={handleDelete}
                  noDelete={record.type === facilityTypeIds.headquarter}
                  isConfigurator={true}
                />
              ) : null
          }
        ] as any)
      : [])
  ];

  return (
    <div>
      <TableTitleHeader
        title="Facility List"
        blockAddition={hasMaxLimitReached(countModule.facility)}
        shouldDisable={refresh}
        filter={{facilityId: '', selectedYear}}
        addButton={{
          setShowModel,
          setIsEdit,
          buttonTitle: 'Add Facility'
        }}
        sampleDownload={{href: SampleExcel.facility.default}}
        jobs={{setShowJobs, uploadType: uploadTypes.FacilityInfo}}
        deleteButton={{selectedRowKeys, handleDelete}}
        refresh={{setRefresh}}
        isTable={true}
        onlyYear={true}
        shouldEdit={!hasUserRole(UserRole.View_Only)}
        onSelectAll={
          !hasUserRole(UserRole.View_Only) ? handleSelectAll : undefined
        }
        allSelectableCount={
          dataSource.filter((row) => row.type !== facilityTypeIds.headquarter)
            .length
        }
        onDeselectAll={() => {
          setSelectedRowKeys([]);
        }}
        // accessModuleType={accessModule.facility}
        // accessModuleDataLimit={getAvailableDataLimit(countModule.facility)}
      />
      <Flex>
        <JobsModal
          open={showJobs}
          onCancel={() => {
            setShowJobs(false);
            setRefresh(true);
          }}
          type={uploadTypes.FacilityInfo}
          details={`null/${selectedYear}`}
        />
      </Flex>
      {isListView ? (
        <TableAnt
          // getPopupContainer={(triggerNode) =>
          //   triggerNode.closest(
          //     '.ant-modal, .ant-drawer, [style*="position"]'
          //   ) as HTMLElement
          // }
          rowSelection={createBulkRowSelection<DataType>({
            selectedRowKeys,
            setSelectedRowKeys,
            onSelectAll: handleSelectAll,
            onDeselectAll: () => {
              setSelectedRowKeys([]);
            },
            getCheckboxProps: (record: DataType) => ({
              disabled: record.type === facilityTypeIds.headquarter
            })
          })}
          rowKey="_id"
          dataSource={dataSource}
          columns={columns as any}
          scroll={{x: 'auto'}}
          loading={{
            indicator: <Loader />,
            spinning: isRefresh
          }}
        />
      ) : (
        <MapView
          data={dataSource}
          handleDelete={handleDelete}
          setEditData={setEditData}
          setIsEdit={setIsEdit}
          setShowModel={setShowModel}
          isLoading={isRefresh}
        />
      )}
      {isListView && hasMaxLimitReached(countModule.facility) ? (
        <BlockAccessPage
          messageTitle={blockModelMessages.facility.title.limitReached}
          messageDescription={blockModelMessages.facility.description.limitReached(
            getSubscriptionPlanType(),
            getModuleDataLimit(accessModule.facility)
          )}
          blockedType={blockAccessTypes.PARTIAL}
        />
      ) : null}
      <DrawerForm
        open={showModel}
        onCancel={() => {
          setShowModel(false);
        }}
        setRefresh={setRefresh}
        data={isEdit ? editData : undefined}
        FormComponent={
          <FacilityForm
            data={isEdit ? editData : undefined}
            setSelectedCountry={setSelectedCountry}
            isHeadquarterExist={checkHeadquarterAvailable()}
          />
        }
        API={facilityDetailsFetch}
        idKey={`${companyId}/${selectedYear}`}
        stepsTitle={['Facility Details', 'Biodiversity Details']}
        formPreview={facilityKeyLabel}
        table={true}
        onlyYear={true}
        isConfigurator={true}
      />
    </div>
  );
};

export default FacilityTable;
